import { createCRUDHook } from './createCRUDHook';
import { PartHardwareDto } from 'utils/models';
import { PART_HARDWARE } from './apiEndPoints';

const { Context, useManager, useConsumer } = createCRUDHook<PartHardwareDto>({
  entityName: 'HardwareTab',
  endpoint: PART_HARDWARE,
});

export const HardwareTabContext = Context;
export const useHardwareTabManager = useManager;
export const useHardwareTab = useConsumer;
